export default "__VITE_ASSET__fcecffb0__"